import { useTranslation } from 'react-i18next';

import { InfoModal } from '../InfoModal/constants';

import * as SC from './HeaderStyles';

import CloseIcon from '@/assets/icons/close.svg?react';
import YourLogo from '@/assets/icons/your-logo.svg?react';
import { useCancelVerification } from '@/hooks/use-cancel-verification';
import { toggleInfoModalAction } from '@/providers/app-provider/actions';
import { useAppContext } from '@/providers/app-provider/context';
import * as GSC from '@/styles/GlobalStyles';

type Props = {
  showCancelVerification?: boolean;
};

export const Header = ({ showCancelVerification = true }: Props) => {
  const { t } = useTranslation();
  const { dispatch, state } = useAppContext();
  const cancelVerification = useCancelVerification();

  function handleCancelClick() {
    // If modal is already opened as SESSION_EXPIRED, just cancel verification
    if (state.infoModal === InfoModal.SESSION_EXPIRED) {
      cancelVerification();

      return;
    }

    dispatch(toggleInfoModalAction(InfoModal.CANCEL_VERIFICATION));
  }

  return (
    <SC.Header>
      <GSC.PageWrapper>
        <SC.HeaderContent>
          <SC.LogoWrapper>
            {state.customerData?.logo ? <img alt="Logo" src={state.customerData.logo} /> : <YourLogo />}
          </SC.LogoWrapper>
          {showCancelVerification && (
            <SC.LinkButton id="btn_cancel_verif" onClick={handleCancelClick} type="button">
              <SC.ButtonText>{t('common.header.cancelButton')}</SC.ButtonText>
              <SC.ButtonIconWrapper>
                <CloseIcon />
              </SC.ButtonIconWrapper>
            </SC.LinkButton>
          )}
        </SC.HeaderContent>
      </GSC.PageWrapper>
    </SC.Header>
  );
};
